import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthEmailSuccess } from '@monorepo/shared-lib';
import Logo from 'assets/images/generateTAX-logo.svg';
import routes from 'routes';

interface SignUpSuccessProps {
  resetPassword?: boolean;
}

export const SignUpSuccess: React.FC<SignUpSuccessProps> = ({
  resetPassword,
}) => {
  const { t } = useTranslation();

  return (
    <AuthEmailSuccess
      mode={resetPassword ? 'resetPassword' : 'signup'}
      logo={Logo}
      logoLinkTo={routes.login}
      siteTitle={t('common.site-title')}
      labels={{
        logoAriaLabel: t('login.logo-aria-label'),
        emailSentTitle: t('forgot-password.email-sent-title'),
        emailSentDescription1: t('forgot-password.email-sent-description1'),
        emailSentDescription2: t('forgot-password.email-sent-description2'),
        successTitle: t('signup.success-title'),
        successDescription1: t('signup.success-description1'),
        successDescription2: t('signup.success-description2'),
        spamTitle: t('signup.spam-title'),
        spamDescription1: t('signup.spam-description1'),
        spamDescription2: t('signup.spam-description2'),
        backToLogin: t('forgot-password.back-to-login'),
      }}
    />
  );
};
